import React from 'react';
import SummaryCard from '../shared/SummaryCard';

const VideosSection = ({ videosData, onViewDetails }) => {
    if (!videosData || !videosData.videos || videosData.videos.length === 0) {
        return null;
    }

    const { total_videos, total_unique_videos, videos, video_type_stats } = videosData;

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Videos</h4>
                <button
                    onClick={onViewDetails}
                    style={{
                        backgroundColor: '#3a3a3a',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 14px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4a4a4a'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                >
                    View video details
                </button>
            </div>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                    gap: '15px'
                }}>
                    <SummaryCard label="Total Videos" value={total_videos ?? 0} />
                    <SummaryCard label="Unique Videos" value={total_unique_videos ?? videos.length} />
                </div>
                {video_type_stats && Object.keys(video_type_stats).length > 0 && (
                    <div style={{ marginTop: '20px' }}>
                        <div style={{
                            fontSize: '12px',
                            color: '#9a9a9a',
                            textTransform: 'uppercase',
                            marginBottom: '12px',
                            fontWeight: '600',
                            letterSpacing: '0.5px'
                        }}>
                            Video Types
                        </div>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            {Object.entries(video_type_stats).map(([type, count]) => (
                                <span
                                    key={type}
                                    style={{
                                        display: 'inline-block',
                                        backgroundColor: '#1e3a5f',
                                        color: '#60a5fa',
                                        padding: '6px 12px',
                                        borderRadius: '12px',
                                        fontSize: '12px',
                                        fontWeight: '500'
                                    }}
                                >
                                    {type}: {count}
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VideosSection;

